module.exports = __webpack_public_path__ + "static/media/phone.445741f9.svg";